<template>
  <div class="logo">
    <a :href="link">
        <img
            v-if="app"
            :src="app.photo"
            :alt="app.name"
            :height="height"
        />
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Logo',
  props: {
    height: {
        type: Number,
        required: false,
        default: 120
    },
    link: {
        type: String,
        required: false,
        default: '/'
    },
  },
  computed: {
    ...mapGetters('app', ['app']),
  }
};
</script>

<style lang="less" scoped>

</style>